<template>
  <div class="device-tab">
    <div class="device-tab__thumb" :style="thumbStyle" />
    <div v-for="(item, index) in deviceList" :key="index" class="item cursor-pointer" @click="handleClick(index)">
      <im-icon class="text-white" :icon="iconMap[item.value]" />
      <span class="ml-1">{{ item.label }}</span>
    </div>
    <!-- <div class="item cursor-pointer" @click="toggleFullScreen">
      <i class="el-icon-full-screen text-white text-12"></i>
      <span class="ml-1">全屏</span>
    </div> -->
  </div>
</template>
<script>
import { DeviceList } from "~/settings/deviceSetting";
import {DeviceEnum} from "~/enums/deviceEnum";
export default {
  name: 'DeviceTab',
  props: {
    fullScreen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      deviceList: DeviceList,
      left: 0,
      iconMap: {
        mobile: 'icon-yidongduan',
        desktop: 'icon-zhuomianduan'
      }
    }
  },
  watch: {
    fullScreen(val) {
      if (val) {
        this.left = 160
      }
    }
  },
  computed: {
    thumbStyle() {
      if (this.fullScreen) {
        return {
          transform: `translateX(160px)`
        }
      }
      return {
        transform: `translateX(${this.left}px)`
      }
    }
  },
  methods: {
    handleClick(index) {
      this.left = index === 0 ? 0 : 80
      this.$emit('change', this.deviceList[index]?.value)
      this.$emit('toggle-full-screen', false)
    },
    toggleFullScreen() {
      this.left = 160
      this.$emit('change', DeviceEnum.DESKTOP)
      this.$emit('toggle-full-screen', true)
    }
  }
}
</script>

<style lang="less">
.device-tab {
  display: flex;
  align-items: center;
  padding: 4px;
  border-radius: 8px; // 更圆润的圆角
  background-color: rgba(255, 255, 255, 0.05); // 更轻盈的背景
  border: 1px solid rgba(255, 255, 255, 0.08);
  position: relative;
  
  &__thumb {
    background-color: rgba(255, 255, 255, 0.1); // 使用柔和的高亮色代替强烈的 primary
    height: 28px; // 略微增加高度
    width: 80px;
    position: absolute;
    border-radius: 6px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .item {
    width: 80px;
    height: 28px;
    font-size: 13px;
    color: var(--text-light-color); // 默认颜色
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    transition: color 0.3s;
    
    // 图标样式优化
    .im-icon, i {
      font-size: 14px;
      margin-right: 4px;
      opacity: 0.8;
    }

    &:hover {
      color: #fff;
    }
  }
}
</style>
